import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { YesNoCancelDialogComponent } from './yes-no-cancel-dialog.component'

@NgModule({
    declarations: [YesNoCancelDialogComponent],
    exports: [YesNoCancelDialogComponent],
    imports: [CommonModule],
})
export class YesNoCancelDialogModule {}
